"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initializeRteConfig = initializeRteConfig;
exports.getRteConfig = getRteConfig;
exports.createRteConfig = createRteConfig;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _ActivityTypes = require("customer-data-objects/constants/ActivityTypes");

var _EngagementTypes = require("customer-data-objects/engagement/EngagementTypes");

var _draftExtend = require("draft-extend");

var _CopyOverride = _interopRequireDefault(require("draft-plugins/plugins/CopyOverride"));

var _ImagePaste = _interopRequireDefault(require("draft-plugins/plugins/ImagePaste"));

var _immutable = require("immutable");

var _invariant = _interopRequireDefault(require("react-utils/invariant"));

var _get = _interopRequireDefault(require("transmute/get"));

var _PluginsConfig = require("./PluginsConfig");

var _RichTextEditorConfiguration = _interopRequireDefault(require("./RichTextEditorConfiguration"));

var _RichTextEditorContent = require("./RichTextEditorContent");

var _Map;

var DEFAULT = 'default';
var UNKNOWN_CONFIG_ERROR = 'Unknown RichTextEditor config type %s';
var INIT_ERROR = 'RichTextEditorDefaultConfigurations not initialized';

var DEFAULT_PLUGIN_COMPOSERS = _immutable.Seq.of(_CopyOverride.default);

var DEFAULT_RTE_CONFIG_OPTIONS = {
  hasContent: _RichTextEditorContent.hasContent,
  pluginComposers: DEFAULT_PLUGIN_COMPOSERS
};
var CONFIG = (0, _immutable.Map)((_Map = {}, (0, _defineProperty2.default)(_Map, DEFAULT, null), (0, _defineProperty2.default)(_Map, _EngagementTypes.TASK, null), (0, _defineProperty2.default)(_Map, _EngagementTypes.MEETING, null), (0, _defineProperty2.default)(_Map, _EngagementTypes.CALL, null), (0, _defineProperty2.default)(_Map, _EngagementTypes.EMAIL, null), (0, _defineProperty2.default)(_Map, _EngagementTypes.NOTE, null), (0, _defineProperty2.default)(_Map, _ActivityTypes.EMAIL_ACTIVITY, null), _Map));

var init = function init(_opts) {
  var _Map2;

  var opts = (0, _PluginsConfig.withDefaultOptions)(_opts);
  var hasToolbarBeta = opts.hasToolbarBeta,
      hasVideo = opts.hasVideo;

  var _createPlugins = (0, _PluginsConfig.createPlugins)(opts),
      plugins = _createPlugins.plugins,
      groups = _createPlugins.groups;

  var filterEnabled = function filterEnabled() {
    for (var _len = arguments.length, selection = new Array(_len), _key = 0; _key < _len; _key++) {
      selection[_key] = arguments[_key];
    }

    return (0, _immutable.Seq)(selection).filter(function (e) {
      return !opts[e] || (0, _get.default)('enabled', opts[e]) !== false;
    }).map(function (e) {
      return plugins[e];
    });
  };

  var baseRteConfiguration = new _RichTextEditorConfiguration.default({
    type: 'base',
    plugins: filterEnabled(_PluginsConfig.PLUGINS.atMention, _PluginsConfig.PLUGINS.inlineStyles, _PluginsConfig.PLUGINS.inlineStylesOverride, _PluginsConfig.PLUGINS.snippets),
    pluginComposers: DEFAULT_PLUGIN_COMPOSERS,
    hasContent: _RichTextEditorContent.hasContent
  }).configureWith(_draftExtend.compose);
  var defaultConfiguration = new _RichTextEditorConfiguration.default({
    type: DEFAULT,
    plugins: filterEnabled(_PluginsConfig.PLUGINS.atMention),
    pluginComposers: DEFAULT_PLUGIN_COMPOSERS,
    hasContent: _RichTextEditorContent.hasContent
  }).configureWith(_draftExtend.compose);
  var meetingRteConfiguration = baseRteConfiguration.set('type', _EngagementTypes.MEETING);
  var taskRteConfiguration = new _RichTextEditorConfiguration.default({
    type: _EngagementTypes.TASK,
    plugins: filterEnabled(_PluginsConfig.PLUGINS.atMention, _PluginsConfig.PLUGINS.inlineStyles, _PluginsConfig.PLUGINS.inlineStylesOverride, _PluginsConfig.PLUGINS.snippets, _PluginsConfig.PLUGINS.image),
    pluginComposers: _immutable.Seq.of(_CopyOverride.default, _ImagePaste.default),
    hasContent: _RichTextEditorContent.hasContent
  }).configureWith(_draftExtend.compose);
  var callRteConfiguration = new _RichTextEditorConfiguration.default({
    type: _EngagementTypes.CALL,
    plugins: _immutable.Seq.of.apply(_immutable.Seq, (0, _toConsumableArray2.default)(filterEnabled(_PluginsConfig.PLUGINS.atMention)).concat([groups.inline.external], (0, _toConsumableArray2.default)(filterEnabled(_PluginsConfig.PLUGINS.link, _PluginsConfig.PLUGINS.snippets, _PluginsConfig.PLUGINS.image)))),
    pluginComposers: _immutable.Seq.of(_CopyOverride.default, _ImagePaste.default),
    hasContent: _RichTextEditorContent.hasContent
  }).configureWith(_draftExtend.compose);
  var ungroupedEmailPlugins = [_PluginsConfig.PLUGINS.link, _PluginsConfig.PLUGINS.image, _PluginsConfig.PLUGINS.unstyledAsDiv, _PluginsConfig.PLUGINS.snippets, _PluginsConfig.PLUGINS.knowledgeArticles];

  if (hasVideo) {
    ungroupedEmailPlugins.push(_PluginsConfig.PLUGINS.video);
  }

  var emailPlugins = hasToolbarBeta ? _immutable.Seq.of.apply(_immutable.Seq, (0, _toConsumableArray2.default)(filterEnabled(_PluginsConfig.PLUGINS.inlineStyles, _PluginsConfig.PLUGINS.inlineStylesOverride)).concat([groups.inline.externalBeta], (0, _toConsumableArray2.default)(filterEnabled(_PluginsConfig.PLUGINS.separator, _PluginsConfig.PLUGINS.link, _PluginsConfig.PLUGINS.image, _PluginsConfig.PLUGINS.unstyledAsDiv)), (0, _toConsumableArray2.default)(groups.inline.externalInsertBeta))) : _immutable.Seq.of.apply(_immutable.Seq, [groups.inline.external].concat((0, _toConsumableArray2.default)(filterEnabled.apply(void 0, ungroupedEmailPlugins))));
  var emailRteConfiguration = new _RichTextEditorConfiguration.default({
    type: _EngagementTypes.EMAIL,
    plugins: emailPlugins,
    pluginComposers: _immutable.Seq.of(_CopyOverride.default, _ImagePaste.default),
    hasContent: _RichTextEditorContent.hasContent
  }).configureWith(_draftExtend.compose);
  var emailActivityRteConfiguration = new _RichTextEditorConfiguration.default({
    type: _ActivityTypes.EMAIL_ACTIVITY,
    plugins: _immutable.Seq.of.apply(_immutable.Seq, (0, _toConsumableArray2.default)(filterEnabled(_PluginsConfig.PLUGINS.atMention)).concat([groups.inline.external], (0, _toConsumableArray2.default)(filterEnabled(_PluginsConfig.PLUGINS.link, _PluginsConfig.PLUGINS.snippets, _PluginsConfig.PLUGINS.knowledgeArticles)))),
    pluginComposers: DEFAULT_PLUGIN_COMPOSERS,
    hasContent: _RichTextEditorContent.hasContent
  }).configureWith(_draftExtend.compose);
  var noteRteConfiguration = new _RichTextEditorConfiguration.default({
    type: _EngagementTypes.NOTE,
    plugins: _immutable.Seq.of.apply(_immutable.Seq, [groups.inline.internal].concat((0, _toConsumableArray2.default)(filterEnabled(_PluginsConfig.PLUGINS.link, _PluginsConfig.PLUGINS.atMention, _PluginsConfig.PLUGINS.snippets, _PluginsConfig.PLUGINS.image, _PluginsConfig.PLUGINS.knowledgeArticles)))),
    pluginComposers: _immutable.Seq.of(_CopyOverride.default, _ImagePaste.default),
    hasContent: _RichTextEditorContent.hasContent
  }).configureWith(_draftExtend.compose);
  CONFIG = (0, _immutable.Map)((_Map2 = {}, (0, _defineProperty2.default)(_Map2, DEFAULT, defaultConfiguration), (0, _defineProperty2.default)(_Map2, _EngagementTypes.TASK, taskRteConfiguration), (0, _defineProperty2.default)(_Map2, _EngagementTypes.MEETING, meetingRteConfiguration), (0, _defineProperty2.default)(_Map2, _EngagementTypes.CALL, callRteConfiguration), (0, _defineProperty2.default)(_Map2, _EngagementTypes.EMAIL, emailRteConfiguration), (0, _defineProperty2.default)(_Map2, _EngagementTypes.NOTE, noteRteConfiguration), (0, _defineProperty2.default)(_Map2, _ActivityTypes.EMAIL_ACTIVITY, emailActivityRteConfiguration), _Map2));
}; // Options
//   atMentions:
//     useInviteZeroState
//     inviteZeroStateOptions


function initializeRteConfig(opts) {
  init(opts);
}

function getRteConfig() {
  var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT;
  (0, _invariant.default)(CONFIG.has(type), UNKNOWN_CONFIG_ERROR, type);
  var config = CONFIG.get(type);
  (0, _invariant.default)(config, INIT_ERROR);
  return config;
}

function createRteConfig(type) {
  var plugins = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, _immutable.Seq)();
  var pluginComposers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (0, _immutable.Seq)();
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var config = CONFIG.get(type);
  (0, _invariant.default)(config !== null, INIT_ERROR); // undefined is valid

  if (!config) {
    options = Object.assign({
      type: type
    }, DEFAULT_RTE_CONFIG_OPTIONS, options);
    config = new _RichTextEditorConfiguration.default(options);
  }

  plugins = (0, _immutable.Seq)(plugins);
  pluginComposers = (0, _immutable.Seq)(pluginComposers);

  if (!plugins.isEmpty() || !pluginComposers.isEmpty()) {
    config = config.enhanceWith(Date.now(), plugins, pluginComposers).configureWith(_draftExtend.compose);
  }

  return config;
}